/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Colleague_Action_Dfsm_AndroidInputs */

const en_colleague_action_dfsm_android = /** @type {(inputs: Colleague_Action_Dfsm_AndroidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Download DFSM for Android`)
};

const ja_colleague_action_dfsm_android = /** @type {(inputs: Colleague_Action_Dfsm_AndroidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DFSM (Android) をダウンロード`)
};

const fr_colleague_action_dfsm_android = /** @type {(inputs: Colleague_Action_Dfsm_AndroidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Télécharger DFSM pour Android`)
};

const de_colleague_action_dfsm_android = /** @type {(inputs: Colleague_Action_Dfsm_AndroidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DFSM für Android herunterladen`)
};

/**
* | output |
* | --- |
* | "Download DFSM for Android" |
*
* @param {Colleague_Action_Dfsm_AndroidInputs} inputs
* @param {{ locale?: "en" | "ja" | "fr" | "de" }} options
* @returns {LocalizedString}
*/
export const colleague_action_dfsm_android = /** @type {((inputs?: Colleague_Action_Dfsm_AndroidInputs, options?: { locale?: "en" | "ja" | "fr" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Colleague_Action_Dfsm_AndroidInputs, { locale?: "en" | "ja" | "fr" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_colleague_action_dfsm_android(inputs)
	if (locale === "ja") return ja_colleague_action_dfsm_android(inputs)
	if (locale === "fr") return fr_colleague_action_dfsm_android(inputs)
	return de_colleague_action_dfsm_android(inputs)
});